const reactAux = (props)=> props.children

export default reactAux;
